module.exports = __webpack_public_path__ + "static/media/react.ee63e33a.png";